<template>
  <w-flex tag="footer" direction="col" align="stretch" class="actions-bar w-theme--dark">
    <w-flex v-if="isSuperAdmin" class="actions-bar__row" justify="end">
      <w-flex align="center" :gap="4">
        <span class="font-xsmall color-neutral-600"> Dla administratora: </span>

        <w-button
          size="xs"
          class="header-nav-bar__title__button"
          text="Waliduj całość"
          @click="$emit('validate-all')"
        />
      </w-flex>
    </w-flex>

    <w-flex class="actions-bar__row" align="start" justify="space-b">
      <w-button
        variant="outlined"
        icon="exit_to_app"
        text="Wyjdź bez zapisu"
        @click="$emit('cancel')"
      />

      <w-flex align="center" justify="end" wrap="reverse" :gap-x="4" :gap-y="2">
        <autosave-info :need-autosave="needAutosave" />

        <w-button-group variant="clear">
          <w-button color="primary" text="Zapisz" @click="$emit('save', false)" />

          <w-button
            color="primary"
            icon="save"
            text="Zapisz i wyjdź"
            @click="$emit('save', true)"
          />
        </w-button-group>
      </w-flex>
    </w-flex>
  </w-flex>
</template>

<script setup lang="ts">
import AutosaveInfo from './AutosaveInfo.vue';

defineProps<{
  isSuperAdmin?: boolean;
  needAutosave?: boolean;
}>();

defineEmits({
  cancel: null,
  save: null,
  openNavigation: null,
  'validate-all': null,
});
</script>

<style lang="scss">
.actions-bar {
  background: w.color('neutral', 100);
  color: w.color('text');

  &__row {
    padding: calc(w.size('layout-padding') / 2) w.size('layout-padding');

    @include w.media-lg {
      padding: calc(w.size('layout-padding--lg') / 2) w.size('layout-padding--lg');
    }

    @include w.media-md {
      padding: calc(w.size('layout-padding--md') / 2) w.size('layout-padding--md');
    }

    &:not(:last-child) {
      border-bottom: 1px solid w.color('neutral', 200);
    }
  }
}
</style>
